import React from 'react';
const grid = ['#FFDE00', '#99E425', '#12DBB4', '#99E425', '#12DBB4', '#3D05DD', '#12DBB4', '#3D05DD', '#6300FF'];
interface DotMarkProps {
  size?: number;
  className?: string;
}

// A 3×3 dot glyph taken from the AFB logo, used as the brand's accent mark.
export function DotMark({
  size = 14,
  className = ''
}: DotMarkProps) {
  const dot = size / 5;
  return <span aria-hidden="true" className={`inline-grid shrink-0 ${className}`} style={{
    width: size,
    height: size,
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: dot / 2
  }} data-id="element-554" data-mp="2kfzdvuvk0xu4">
      {grid.map((color, index) => <span key={index} className="rounded-full" style={{
      width: dot,
      height: dot,
      background: color
    }} data-id="element-555" data-mp="2ya9xxywlw3tu" data-mpi={index} />)}
    </span>;
}